import { useQuery } from "./useApi";
import { companyUsersService, type CompanyUsersFilters } from "../api/companyUsers.service";

export function useCompanyUsers(filters?: CompanyUsersFilters) {
  return useQuery(
    () => companyUsersService.get(filters),
    [
      filters?.search,
      filters?.company_id,
      filters?.company_firm_ref,
      filters?.limit,
      filters?.offset,
    ],
  );
}
